<template>
<div>

    <el-form ref="userForm" :model="userForm" label-width="80px" :rules="rules">
        <el-row>
            <el-col :lg="12">
                <el-form-item label="職稱:" prop="role">
                    <el-radio-group v-model="userForm.role">
                        <el-radio :label="1">業務</el-radio>
                        <el-radio :label="2">美容師</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="12">
                <el-form-item label="品牌" prop="brand_id">
                    <el-radio-group v-model="userForm.brand_id">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="帳號:" prop="user_id">
                    <el-input v-model="userForm.user_id"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="8">
                <el-form-item label="密碼:" prop="password">
                    <el-input v-model="userForm.password" type="password"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="生日:" prop="birthday">
                    <el-date-picker v-model="userForm.birthday" type="date" placeholder="選擇日期"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :lg="8">
                <el-form-item label="姓名:" prop="name">
                    <el-input v-model="userForm.name"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="電話" prop="phone">
                    <el-input v-model="userForm.phone"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="16"></el-col>
        </el-row>

        <el-row>

            <el-col :lg="22">
                <el-form-item label="地址:" prop="address">
                    <el-select v-model="userForm.city" placeholder="" @change="queryArea" prop="city">
                        <el-option v-for="item in getCityItems" :key="item.city" :label="item.city" :value="item.city">
                        </el-option>
                    </el-select>
                    <el-select v-model="userForm.area" placeholder="" prop="area">
                        <el-option v-for="item in getAreaItems" :key="item.area" :label="item.area" :value="item.area">
                        </el-option>
                    </el-select>

                    <el-input v-model="userForm.address" style="width:50%;"></el-input>

                </el-form-item>

            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="店櫃">
                    <el-select v-model="shop" placeholder="">
                        <el-option v-for="item in shops" :key="item._key" :label="item.name" :value="item._key" clearable>
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="addShop">增加</el-button>
                </el-form-item>

            </el-col>
            <el-col :lg="8">
                <el-table :data="userForm.shops" style="width: 100%" size="small" border>
                    <el-table-column prop="name" label="店櫃" width="auto" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="刪除" align="center">
                        <template slot-scope="scope">
                            <el-button type="danger" icon="el-icon-delete" @click.native.prevent="deleteShop(scope.$index, userForm.shops)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center">
            <el-col :lg="8">
                <el-button type="primary" @click="addUser('userForm')">
                    <i class="el-icon-plus"></i>增加
                </el-button>
                <el-button type="default" @click="removeAdd">返回</el-button>
            </el-col>
        </el-row>

    </el-form>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import moment from 'moment'
import {
    userInfo
} from 'os'
export default {
    name: 'Add',
    data() {
        return {
            userForm: {
                name: '',
                user_id: '',
                password: '',
                phone: '',
                birthday: '',
                area: '',
                city: '',
                address: '',
                brand_id: null,
                role: 1,
                shops: [],
            },
            rules: {
                role: [{
                    required: true,
                    message: '請點選職稱'
                }],
                brand_id: [{
                    required: true,
                    message: '請點選品牌'
                }],
                name: [{
                    required: true,
                    message: '請輸入名字'
                }],
                phone: [{
                    required: true,
                    message: '請輸入電話'
                }],
                user_id: [{
                    required: true,
                    message: '請輸入帳號'
                }],
                password: [{
                    required: true,
                    message: '請輸入密碼'
                }],
                birthday: [{
                    required: true,
                    message: '請輸入生日'
                }],
                city: [{
                    required: true,
                    message: '請輸入城市',
                    trigger: 'blur'
                }],
                area: [{
                    required: true,
                    message: '請輸入區域',
                    trigger: 'blur'
                }],
                address: [{
                    required: true,
                    message: '請輸入地址',
                    trigger: 'blur'
                }]
            },
            shops: [],
            shop: [],
            shopList: [],
            shopInfo: []
        }
    },
    computed: mapGetters(["getShopDetail", "getShopList", "getCityItems", "getAreaItems", "getError"]),
    methods: {
        ...mapActions(["fetchShopDetail", "fetchShop", "fetchCity", "fetchArea"]),
        addUser(formName) {
            const strDate = moment(this.userForm.birthday).format('YYYY-MM-DD')
            let userForm = {
                name: this.userForm.name,
                role: this.userForm.role,
                phone: this.userForm.phone,
                user_id: this.userForm.user_id,
                password: this.userForm.password,
                city: this.userForm.city,
                area: this.userForm.area,
                address: this.userForm.address,
                shops: this.userForm.shops,
                birthday: strDate,
                brand_id: this.userForm.brand_id
            }
            if (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch('AddUser', userForm)
                        if (this.getUserError != true) {
                            this.removeAdd()
                            this.$message('已新增員工');
                        } else {
                            this.$message('無法新增員工')
                        }
                    } else {
                        console.log('無法驗證')
                    }
                })
            }
        },
        removeAdd: function () {
            this.$emit('removeAdd', this.removeUserTabs)
        },
        queryArea() {
            if (this.userForm.area.length != 0) {
                this.userForm.area = ''
                let city = this.userForm.city
                let cityName = {
                    city
                }
                console.log(cityName);
                this.$store.dispatch('fetchArea', cityName)
            } else {
                let city = this.userForm.city
                let cityName = {
                    city
                }
                console.log(cityName);
                this.$store.dispatch('fetchArea', cityName)
            }
        },
        queryShop: function () {
            const data = {}
            this.$store.dispatch('fetchShop', data)
                .then(() => {
                    this.shops = this.getShopList
                }).catch((err) => {
                    console.log(err);
                });
        },
        fetchCity() {
            this.$store.dispatch('fetchCity')
        },
        addShop: function () {
            const data = {
                _key: this.shop
            }
            this.$store.dispatch('fetchShopDetail', data)
                .then(() => {
                    this.userForm.shops.push({
                        shops: this.shop,
                        name: this.getShopDetail.name
                    })
                    this.shop = ''

                }).catch((err) => {
                    console.log(err);
                });

        },
        deleteShop(index, rows) {
            rows.splice(index, 1)
        },

    },
    created() {
        this.fetchCity()
        this.queryShop()
    },
}
</script>

<style  scoped>
    
</style>
